var map = {
	"./BUSANPA/docView/DocView": [
		3641,
		20,
		346,
		553,
		12
	],
	"./DEMO/docView/DocView": [
		7181,
		20,
		346,
		553,
		723
	],
	"./POSTECH/docView/DocView": [
		4294,
		20,
		346,
		553,
		840
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6378;
module.exports = webpackAsyncContext;